module.exports = __webpack_public_path__ + "static/media/IMG_20181114_213249_edited.c692c29b.jpg";